import React, { useEffect, useRef, useState } from 'react';
import * as classes from './index.module.css';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const AnimatedImage = ({ image, height, width, loading = 'lazy', ...props }) => {
    const { gatsbyImageData, description } = image;
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => setHydrated(true), []);
    const imageRef = useRef(null);

    useEffect(() => {
        if (!hydrated) return;
        if (!imageRef.current) return;

        const wrapper = imageRef.current.querySelector(".gatsby-image-wrapper");
        if (!wrapper) return;

        const ctx = gsap.context(() => {
            gsap.fromTo(
                wrapper,
                { scale: 1.08 },
                {
                    scale: 1,
                    ease: "none",
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: "top 80%",
                        end: "bottom top",
                        scrub: true,
                    },
                }
            );
        }, imageRef);

        return () => {
            ctx.revert();
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, [hydrated]);

    return (
        <div className={classes.animatedImage} ref={imageRef} {...props}>
            <GatsbyImage
                image={gatsbyImageData}
                alt={description ?? ""}
                className={classes.image}
                placeholder="blurred"
                height={height}
                width={width}
                loading={loading}
            />
        </div>
    );
};

AnimatedImage.propTypes = {
    image: PropTypes.object.isRequired,
    height: PropTypes.any,
    width: PropTypes.any,
    loading: PropTypes.string,
};

export default AnimatedImage;
